import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { Numbers } from '@factorialco/factorial-one-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import { NumberElementQuestion } from '../../components/QuestionComponent/NumberElementQuestion'
import { Element } from '../Element'
import { Answer, elementParam } from '../types'

/**
 * NumberElement class for numeric input elements.
 * Extends the base Element class.
 */
export class NumberElement extends Element {
  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'number'
  }

  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Numbers
  }
  /**
   * Validate the element's configuration
   */
  validate(): boolean {
    // Basic validation: label should not be empty
    if (!this.label.trim()) {
      return false
    }

    // If min and max are specified, min should be less than max
    const min = this.getParam<number>('min')
    const max = this.getParam<number>('max')
    if (min !== undefined && max !== undefined && min > max) {
      return false
    }

    return true
  }

  getPreviewComponent(): React.ReactNode {
    return <NumberElementQuestion element={this} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <NumberElementQuestion element={this} onChange={onChange} />
  }

  // /**
  //  * Get the minimum value allowed
  //  */
  // get min(): number | undefined {
  //   return this.getParam<number>('min')
  // }
  //
  // /**
  //  * Set the minimum value allowed
  //  */
  // set min(value: number | undefined) {
  //   if (value !== undefined) {
  //     this.setParam('min', value)
  //   }
  // }
  //
  // /**
  //  * Get the maximum value allowed
  //  */
  // get max(): number | undefined {
  //   return this.getParam<number>('max')
  // }
  //
  // /**
  //  * Set the maximum value allowed
  //  */
  // set max(value: number | undefined) {
  //   if (value !== undefined) {
  //     this.setParam('max', value)
  //   }
  // }

  configureParams(): elementParam[] {
    return [Element.numberParam('min', 'Minimun'), Element.numberParam('max', 'Maximun')]
  }
}
